import PromptMessageContainer from "./PromptMessageContainer";

export default PromptMessageContainer;
